import React, {useEffect, useRef, useState} from 'react';
import CustomButton from "../../../../components/Form/Button";
import {getCommission} from "../../../../services/Profile";
import messageTypes from "../../../../constants/MessagesTypes";
import {IoIosArrowBack, IoIosArrowForward} from "react-icons/io";
import {useTranslation} from "react-i18next";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableFooter from "@mui/material/TableFooter";
import Checkbox from "@mui/material/Checkbox";
import {currencyFormat} from "../../../../utils/masks";
import {Form} from "@unform/web";
import Input from "../../../../components/Form/Input";
import {AiOutlineSearch} from "react-icons/ai";
import * as Yup from "yup";
import {toast} from "react-toastify";
import InputSelect from "../../../../components/Form/InputSelect";
import {GoChecklist} from "react-icons/go";
import FormPaymentCommission from "../../../../components/Form/FormPaymentCommission";
import DivDiagonal from "../../../../components/DivDiagonal";
import {
    TradingWrapper,
    ContentArea,
    FilterSection,
    FilterTitle,
    StyledFilterFormWrapper,
    FilterRow,
    FilterField,
    FilterButtonWrap,
} from "../../../Trading/styles";
import {
    StrategyPageHeader,
    StrategyWideCardColumn,
    StrategyProductCard,
    StrategyTableContainer,
    StrategyTableWrapper,
    StrategyPaginationInfo,
    StrategyPaginationButton,
    StrategyLoadingButton,
    StrategyEmptyState,
} from "../../../Strategy/styles";

const commissionCheckboxSx = {
    color: 'rgba(255, 255, 255, 0.35)',
    '&.Mui-checked': {
        color: '#f29205',
    },
    '&.MuiCheckbox-indeterminate': {
        color: '#f29205',
    },
};

const filterSearchBtnStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '0 32px',
    borderRadius: '10px',
    fontWeight: 600,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
    transition: 'all 0.3s ease',
    width: 'auto',
    minWidth: 'auto',
    height: '56px',
    display: 'flex',
    alignItems: 'center',
};

const statusBadge = (pending) => ({
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: 8,
    fontSize: 12,
    fontWeight: 700,
    ...(pending
        ? {
            background: 'rgba(255, 193, 7, 0.15)',
            color: '#ffc107',
            border: '1px solid rgba(255, 193, 7, 0.4)',
        }
        : {
            background: 'rgba(46, 204, 113, 0.15)',
            color: '#5bd37c',
            border: '1px solid rgba(46, 204, 113, 0.4)',
        }),
});

const registerPaymentBtnStyle = {
    background: 'rgba(46, 204, 113, 0.18)',
    border: '1px solid rgba(46, 204, 113, 0.5)',
    color: '#7ee8a0',
    padding: '10px 18px',
    borderRadius: 8,
    fontWeight: 600,
    fontSize: 14,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    transition: 'all 0.2s ease',
};

export default function Commission() {
  const [openModalPayment, setOpenModalPayment] = useState(false);
  const [loadingList, setLoadingList] = useState(false);
  const { t } = useTranslation();
  const [commissions, setCommissions] = useState([]);
  const [page, setPage] = useState(1);
  const formRef = useRef(null);
  const [filter, setFilter] = useState({
    stringSearch: '',
    status: 'PENDING',
  });

  const optionsStatus = [
    {key: 'PENDING', value: t('admin_commissions_status_pending')},
    {key: 'PAY', value: t('admin_commissions_status_paid')},
  ];

  const [selectedCommissions, setSelectedCommissions] = useState([]);

  const handleSelectCommission = (id) => {
    setSelectedCommissions((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  async function handleSubmit(data) {
    try {

      formRef.current.setErrors({});
      const schema = Yup.object().shape({});

      await schema.validate(data, {
        abortEarly: false,
      });

      setPage(1);
      setFilter({
        stringSearch: data.stringSearch,
        status: data.status
      });

    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const validationErrors = {};
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
        toast.warning(messageTypes.REQUIRED_FIELDS);
        return;
      }

      toast.error(messageTypes.ERROR);
    }
  }

  useEffect( () => {
    setLoadingList(true);
    getCommission({
      page: page,
      per_page: 25,
      stringSearch: filter.stringSearch,
      status: filter.status,
    }).then((data) => {
      if (!data || data === '') {
        return;
      }

      setCommissions(data.data);
    }).finally(() => {
      setLoadingList(false);
    });

    return function cleanup() {
      setCommissions([]);
    };
  }, [page, filter]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePaymentCommission = () => {
    setOpenModalPayment(true);
  };

    const rowCount = commissions?.data?.length || 0;

    return (
      <>
        <TradingWrapper>
            <DivDiagonal/>
            <ContentArea>
                <StrategyPageHeader>
                    <h1>
                        <i className="fa fa-hand-holding-usd" aria-hidden="true"/>
                        {' '}{t('admin_commissions_title')}{' '}
                        <span className="badge">{rowCount}</span>
                    </h1>
                </StrategyPageHeader>

                <StrategyWideCardColumn>
                    <StrategyProductCard>
                        <FilterSection>
                            <StyledFilterFormWrapper>
                                <Form ref={formRef} onSubmit={handleSubmit}>
                                    <FilterTitle>
                                        <i className="fas fa-filter"/> {t('filter')}
                                    </FilterTitle>
                                    <FilterRow>
                                        <FilterField>
                                            <Input
                                                type="text"
                                                name="stringSearch"
                                                placeholder={t('admin_commissions_search_placeholder')}
                                                label={t('admin_commissions_search_label')}
                                                size={"small"}
                                            />
                                        </FilterField>
                                        <FilterField>
                                            <InputSelect
                                                type="text"
                                                name="status"
                                                label={t('admin_commissions_filter_status')}
                                                options={optionsStatus}
                                                defaultValue={'PENDING'}
                                                size={"small"}
                                            />
                                        </FilterField>
                                        <FilterButtonWrap>
                                            <CustomButton
                                                className="btn font-weight-bold text-capitalize mobile-button"
                                                type="submit"
                                                startIcon={<AiOutlineSearch/>}
                                                style={filterSearchBtnStyle}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
                                                }}
                                            >
                                                {t('filter_btn_submmit')}
                                            </CustomButton>
                                        </FilterButtonWrap>
                                    </FilterRow>
                                </Form>
                            </StyledFilterFormWrapper>
                        </FilterSection>

                        <StrategyTableWrapper>
                            {loadingList ? (
                                <StrategyLoadingButton
                                    className="btn btn-primary text-capitalize font-weight-bold"
                                    loading={loadingList}
                                    type="button"
                                >
                                    {t('loading')}
                                </StrategyLoadingButton>
                            ) : (
                                <>
                                    {commissions && commissions.data && commissions.data.length ? (
                                        <StrategyTableContainer>
                                            <Table aria-label={t('admin_commissions_title')}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell padding="checkbox">
                                                            <Checkbox
                                                                sx={commissionCheckboxSx}
                                                                indeterminate={
                                                                    selectedCommissions.length > 0 &&
                                                                    selectedCommissions.length < commissions.data.length
                                                                }
                                                                checked={
                                                                    commissions.data.length > 0 &&
                                                                    selectedCommissions.length === commissions.data.length
                                                                }
                                                                onChange={(e) => {
                                                                    if (e.target.checked) {
                                                                        setSelectedCommissions(
                                                                            commissions.data.map((c) => c.id)
                                                                        );
                                                                    } else {
                                                                        setSelectedCommissions([]);
                                                                    }
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell>{t('admin_commissions_col_date')}</TableCell>
                                                        <TableCell>{t('admin_commissions_col_affiliate')}</TableCell>
                                                        <TableCell>{t('admin_commissions_col_value')}</TableCell>
                                                        <TableCell>{t('admin_commissions_col_status')}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {commissions.data.map((commission) => (
                                                        <TableRow key={commission.id}>
                                                            <TableCell padding="checkbox">
                                                                <Checkbox
                                                                    sx={commissionCheckboxSx}
                                                                    checked={selectedCommissions.includes(commission.id)}
                                                                    onChange={() => handleSelectCommission(commission.id)}
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                {new Date(commission.created.date).toLocaleDateString()}
                                                            </TableCell>
                                                            <TableCell>
                                                                {commission.affiliateUser ? commission.affiliateUser.email : ''}
                                                                <br/>
                                                                <small style={{ color: 'rgba(255,255,255,0.45)' }}>
                                                                    ID: {commission.affiliateUser ? (commission.affiliateUser.id).split('-')[0] : ''}
                                                                    <br/>
                                                                    {t('admin_commissions_affiliate_id')}: {commission.affiliateUser ? (commission.affiliateUser.affiliateID).split('-')[0] : ''}
                                                                </small>
                                                            </TableCell>
                                                            <TableCell>
                                                                {currencyFormat(parseFloat(commission.value ? commission.value : 0), 'R$')}
                                                            </TableCell>
                                                            <TableCell>
                                                                {!commission.status ? '—' : null}
                                                                {commission.status === 'PENDING' && (
                                                                    <span style={statusBadge(true)}>
                                                                        {t('admin_commissions_status_pending')}
                                                                    </span>
                                                                )}
                                                                {commission.status === 'PAY' && (
                                                                    <span style={statusBadge(false)}>
                                                                        {t('admin_commissions_status_paid')}
                                                                    </span>
                                                                )}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                                <TableFooter>
                                                    <TableRow>
                                                        <TableCell colSpan={5}>
                                                            <div style={{
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                gap: 14,
                                                            }}>
                                                                {selectedCommissions.length > 0 && (
                                                                    <div>
                                                                        <button
                                                                            type="button"
                                                                            onClick={handlePaymentCommission}
                                                                            style={registerPaymentBtnStyle}
                                                                        >
                                                                            <GoChecklist size={18}/>
                                                                            {t('admin_commissions_register_payment')}
                                                                        </button>
                                                                    </div>
                                                                )}
                                                                <div style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    flexWrap: 'wrap',
                                                                    gap: 12,
                                                                }}>
                                                                    <StrategyPaginationInfo>
                                                                        {t('table_pagination_text', {
                                                                            page,
                                                                            totalPage: commissions.total_page + 1,
                                                                        })}
                                                                    </StrategyPaginationInfo>
                                                                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                                                        <StrategyPaginationButton
                                                                            type="button"
                                                                            onClick={() => setPage(page - 1)}
                                                                            disabled={page <= 1}
                                                                        >
                                                                            <IoIosArrowBack/> {t('table_pagination_back')}
                                                                        </StrategyPaginationButton>
                                                                        <StrategyPaginationButton
                                                                            type="button"
                                                                            onClick={() => setPage(page + 1)}
                                                                            disabled={!commissions.next_page}
                                                                        >
                                                                            {t('table_pagination_next')} <IoIosArrowForward/>
                                                                        </StrategyPaginationButton>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableFooter>
                                            </Table>
                                        </StrategyTableContainer>
                                    ) : (
                                        <StrategyEmptyState>
                                            <i className="fa fa-hand-holding-usd" aria-hidden="true"/>
                                            <p>{t('admin_commissions_empty_title')}</p>
                                            <span>{t('admin_commissions_empty_subtitle')}</span>
                                        </StrategyEmptyState>
                                    )}
                                </>
                            )}
                        </StrategyTableWrapper>
                    </StrategyProductCard>
                </StrategyWideCardColumn>
            </ContentArea>
        </TradingWrapper>

        <FormPaymentCommission
            isOpen={openModalPayment}
            commissions={selectedCommissions}
            handleClose={() => { setOpenModalPayment(false); }}
        />
      </>
    );
}
